
document.addEventListener("DOMContentLoaded", () => {
  console.log("Prysmian ISY theme JS loaded");

  // ===== SÉLECTEURS DOM =====
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu");
  const mobileMenuOverlay = document.querySelector(".mobile-menu-overlay");
  const mobileMenuClose = document.querySelector(".mobile-menu-close");
  const siteHeader = document.querySelector(".site-header");
  const body = document.body;

  // ===== MENU MOBILE =====

  /**
   * Ouvrir le menu mobile
   */
  function openMobileMenu() {
    mobileMenu?.classList.add("open");
    mobileMenuOverlay?.classList.add("open");
    mobileMenuToggle?.classList.add("active");
    body.style.overflow = "hidden";
  }

  /**
   * Fermer le menu mobile
   */
  function closeMobileMenu() {
    mobileMenu?.classList.remove("open");
    mobileMenuOverlay?.classList.remove("open");
    mobileMenuToggle?.classList.remove("active");
    body.style.overflow = "";
  }

  /**
   * Toggle menu mobile au clic sur le bouton burger
   */
  mobileMenuToggle?.addEventListener("click", (e) => {
    e.preventDefault();

    if (mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  /**
   * Fermer le menu via l'overlay
   */
  mobileMenuOverlay?.addEventListener("click", closeMobileMenu);

  /**
   * Fermer le menu via le bouton close
   */
  mobileMenuClose?.addEventListener("click", closeMobileMenu);

  /**
   * Fermer le menu au redimensionnement si on passe en desktop
   */
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768 && mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    }
  });

  // Smooth scroll géré nativement par CSS via `scroll-behavior: smooth`
  // (cf. _base.scss). Le navigateur respecte automatiquement scroll-margin-block-start,
  // met à jour l'URL hash, gère prefers-reduced-motion — plus fiable que du JS custom.

  // ===== TOC SCROLLSPY (single article) =====

  /**
   * Sur les pages d'article single, met en valeur dans le sommaire le lien
   * correspondant à la section actuellement en train d'être lue.
   * IntersectionObserver natif : performant (déclenché par le navigateur, pas un
   * scroll listener custom), pas de polling.
   */
  const tocLinks = document.querySelectorAll(".single-content__toc-link");
  const tocHeadings = document.querySelectorAll(".single-content__body h2[id]");

  if (tocLinks.length && tocHeadings.length && "IntersectionObserver" in window) {
    const activate = (id) => {
      tocLinks.forEach((link) => {
        link.classList.toggle("is-active", link.getAttribute("href") === `#${id}`);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        // Active le H2 le plus haut visible dans la zone de lecture.
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.target.offsetTop - b.target.offsetTop);
        if (visible.length > 0) {
          activate(visible[0].target.id);
        }
      },
      {
        // Zone "active" : du 0% au 20% du viewport (proche du haut). Le H2 doit
        // s'approcher du sommet de l'écran avant que le sommaire ne bascule sur
        // la nouvelle section → meilleure correspondance entre ce que l'utilisateur
        // lit et ce qui est mis en valeur dans le sommaire.
        rootMargin: "0px 0px -80% 0px",
        threshold: 0,
      }
    );

    tocHeadings.forEach((h) => observer.observe(h));
  }

  // ===== ACCESSIBILITÉ : ESC POUR FERMER LE MENU =====

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    }
  });

  // ===== TRAP FOCUS DANS LE MENU MOBILE =====

  mobileMenu?.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      const focusableElements = mobileMenu.querySelectorAll(
        'a, button, input, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // Tab + Shift : retour au dernier élément
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
      // Tab seul : retour au premier élément
      else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });

  // ===== ACCORDION TÉMOIGNAGES =====

  /**
   * Sur la grille de témoignages, une seule carte est ouverte (citation visible) à la fois.
   * Au clic sur le chevron d'une carte, on ferme les autres et on toggle celle-ci.
   */
  const temoignageCards = document.querySelectorAll(".home-temoignages__card");

  temoignageCards.forEach((card) => {
    const toggle = card.querySelector(".home-temoignages__toggle");
    const citation = card.querySelector(".home-temoignages__citation");
    if (!toggle || !citation) return;

    // Click sur la carte entière (le click du button bubble aussi jusqu'ici → 1 seul listener)
    card.addEventListener("click", () => {
      const isOpen = card.classList.contains("home-temoignages__card--active");

      // Ferme toutes les cartes
      temoignageCards.forEach((c) => {
        c.classList.remove("home-temoignages__card--active");
        const t = c.querySelector(".home-temoignages__toggle");
        const cit = c.querySelector(".home-temoignages__citation");
        if (t) t.setAttribute("aria-expanded", "false");
        if (cit) cit.setAttribute("hidden", "");
      });

      // Si la carte cliquée n'était pas ouverte, on l'ouvre
      if (!isOpen) {
        card.classList.add("home-temoignages__card--active");
        toggle.setAttribute("aria-expanded", "true");
        citation.removeAttribute("hidden");
      }
    });
  });

  // ===== ACCORDION FAQ =====

  /**
   * Une seule question ouverte à la fois. Clic sur le bouton toggle la question correspondante.
   */
  const faqItems = document.querySelectorAll(".home-faq__item");

  faqItems.forEach((item) => {
    const toggle = item.querySelector(".home-faq__toggle");
    const panel = item.querySelector(".home-faq__reponse");
    if (!toggle || !panel) return;

    toggle.addEventListener("click", () => {
      const isOpen = item.classList.contains("home-faq__item--active");

      faqItems.forEach((other) => {
        other.classList.remove("home-faq__item--active");
        const t = other.querySelector(".home-faq__toggle");
        const p = other.querySelector(".home-faq__reponse");
        if (t) t.setAttribute("aria-expanded", "false");
        if (p) p.setAttribute("inert", "");
      });

      if (!isOpen) {
        item.classList.add("home-faq__item--active");
        toggle.setAttribute("aria-expanded", "true");
        panel.removeAttribute("inert");
      }
    });
  });

  // ===== FLOATING LABELS — toggle .is-filled sur le .form-field =====

  /**
   * Le label flotte vers le haut quand le champ est focusé (via :focus-within en CSS)
   * OU quand il contient une valeur (via la classe .is-filled posée ici).
   * Pas de dépendance à placeholder=" " ou au filter PHP : la détection se fait sur
   * la valeur réelle de l'input.
   */
  document.querySelectorAll(".form-field input, .form-field textarea").forEach((el) => {
    const field = el.closest(".form-field");
    if (!field) return;

    const update = () => {
      field.classList.toggle("is-filled", el.value.trim() !== "");
    };

    el.addEventListener("input", update);
    el.addEventListener("change", update);
    el.addEventListener("blur", update);
    update();
  });

  // ===== LITE EMBED VIDÉO (YouTube / Vimeo) =====

  /**
   * Parse une URL YouTube ou Vimeo et retourne l'URL d'embed avec autoplay,
   * ou null si la plateforme n'est pas reconnue.
   */
  function parseVideoUrl(url) {
    const youtubeMatch = url.match(
      /(?:youtu\.be\/|youtube\.com.*[?&]v=|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&?/]+)/
    );
    if (youtubeMatch) {
      return `https://www.youtube-nocookie.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
    }

    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
    }

    return null;
  }

  /**
   * Au clic sur le bouton play d'un embed, remplace le poster par l'iframe.
   * L'iframe n'est jamais chargée tant que l'utilisateur ne clique pas → pas de cookie tracking
   * ni de 500 Ko inutiles avant interaction.
   */
  document.querySelectorAll(".home-video__embed[data-video-url]").forEach((embed) => {
    const playButton = embed.querySelector(".home-video__play");
    if (!playButton) return;

    const launch = () => {
      const iframeSrc = parseVideoUrl(embed.dataset.videoUrl);
      if (!iframeSrc) return;

      const iframe = document.createElement("iframe");
      iframe.src = iframeSrc;
      iframe.title = "Vidéo de démonstration";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;
      iframe.className = "home-video__iframe";

      embed.innerHTML = "";
      embed.appendChild(iframe);
    };

    playButton.addEventListener("click", launch);
  });

  // ===== REDIRECTION APRÈS ENVOI CF7 =====

  /**
   * Contact Form 7 émet l'événement `wpcf7mailsent` sur `document` après un envoi
   * mail réussi (≠ wpcf7submit qui se déclenche aussi sur erreur validation/spam).
   * On redirige vers la page de confirmation /merci/ pour une UX claire et permettre
   * un tracking conversion propre (page vue dédiée).
   */
  document.addEventListener("wpcf7mailsent", () => {
    window.location.href = "/merci/";
  });

});
